export const costs = [
  'Information scattered across manuals, standards, forums and videos',
  'No clear picture of how primary equipment and protection work together',
  'Uncertainty when reading single-line diagrams and relay schemes',
  'Slower career growth in power systems',
];
